var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useMemo, useState } from "react";
import { SimpleForm, useCreate, useGetList, useNotify, useUpdate } from "react-admin";
import { useQuery } from "@apollo/client";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import { useTranslation } from "react-i18next";
import { GET_CONTESTS_EXTENDED } from "@/queries/GetContestsExtended";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import { sortFunction } from "./utils";
import { EEnableCheckableLists, isTallySheetVotingChannel, TallySheetVotingChannel, } from "@sequentech/ui-core";
import { filterCandidateByCheckableLists } from "@/services/CandidatesFilter";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
var votingChannels = [TallySheetVotingChannel.Paper, TallySheetVotingChannel.Postal];
export var ShowTallySheet = function (props) {
    var contest = props.contest, submitRef = props.submitRef, tallySheet = props.tallySheet;
    var notify = useNotify();
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var aliasRenderer = useAliasRenderer();
    var _b = useState([]), areasList = _b[0], setAreasList = _b[1];
    var _c = React.useState(null), channel = _c[0], setChannel = _c[1];
    var _d = useState({
        area_id: "",
        contest_id: "-",
        invalid_votes: {},
        candidate_results: {},
    }), results = _d[0], setResults = _d[1];
    var _e = useState({}), invalids = _e[0], setInvalids = _e[1];
    var _f = useState([]), candidatesResults = _f[0], setCandidatesResults = _f[1];
    var areas = useQuery(GET_CONTESTS_EXTENDED, {
        variables: {
            electionEventId: contest.election_event_id,
            contestId: contest.id,
            tenantId: contest.tenant_id,
        },
    }).data;
    var candidates = useGetList("sequent_backend_candidate", {
        filter: {
            contest_id: contest.id,
            tenant_id: contest.tenant_id,
            election_event_id: contest.election_event_id,
        },
    }).data;
    var checkableLists = useMemo(function () {
        var _a;
        var presentation = contest.presentation;
        return (_a = presentation === null || presentation === void 0 ? void 0 : presentation.enable_checkable_lists) !== null && _a !== void 0 ? _a : EEnableCheckableLists.CANDIDATES_AND_LISTS;
    }, [contest.presentation]);
    useEffect(function () {
        var _a, _b, _c;
        var tallySaved = localStorage.getItem("tallySheetData");
        if ((tallySheet || tallySaved) && candidates) {
            var tallySheetTemp = tallySheet
                ? __assign({}, tallySheet) : JSON.parse(tallySaved || "");
            if (tallySheetTemp.content) {
                var contentTemp = __assign({}, tallySheetTemp.content);
                if (contentTemp.invalid_votes) {
                    var invalidsTemp = __assign({}, contentTemp.invalid_votes);
                    setInvalids(invalidsTemp);
                }
                if (contentTemp.candidate_results) {
                    var candidatesResultsTemp = [];
                    for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
                        var candidate = candidates_1[_i];
                        var isValid = filterCandidateByCheckableLists(candidate, checkableLists);
                        if (!isValid) {
                            continue;
                        }
                        var candidateTemp = {
                            candidate_id: candidate.id,
                            name: aliasRenderer(candidate.presentation),
                            total_votes: (_c = (_b = (_a = contentTemp.candidate_results) === null || _a === void 0 ? void 0 : _a[candidate.id]) === null || _b === void 0 ? void 0 : _b.total_votes) !== null && _c !== void 0 ? _c : 0,
                        };
                        candidatesResultsTemp.push(candidateTemp);
                    }
                    candidatesResultsTemp.sort(sortFunction);
                    setCandidatesResults(candidatesResultsTemp);
                }
                setResults(contentTemp);
            }
            setChannel(tallySheetTemp.channel && isTallySheetVotingChannel(tallySheetTemp.channel)
                ? tallySheetTemp.channel
                : null);
        }
    }, [tallySheet, candidates, i18n.language]);
    useEffect(function () {
        if (contest) {
            setResults(function (prev) { return (__assign(__assign({}, prev), { contest_id: contest.id })); });
        }
    }, [contest]);
    useEffect(function () {
        var _a;
        if (areas) {
            var areatListTemp = (_a = areas === null || areas === void 0 ? void 0 : areas.sequent_backend_area_contest) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                return {
                    id: item.area.id,
                    name: item.area.name,
                };
            });
            setAreasList(areatListTemp);
        }
    }, [areas]);
    useEffect(function () {
        window.scrollTo(0, 0);
    }, []);
    var handleChange = function (event) {
        // setArea(event.target.value as string)
        setResults(function (prev) { return (__assign(__assign({}, prev), { area_id: event.target.value })); });
    };
    var handleTextChange = function (event) {
        setResults(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = event.target.value, _a)));
        });
    };
    var handleInvalidChange = function (event) {
        setInvalids(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[event.target.name] = event.target.value, _a)));
        });
    };
    var handleCandidateChange = function (event) {
        var candidateTemp = candidatesResults.find(function (item) { return item.candidate_id === event.target.id; });
        var candidateRest = candidatesResults.filter(function (item) { return item.candidate_id !== event.target.id; });
        if (candidateTemp) {
            if (!event.target.value) {
                delete candidateTemp.total_votes;
            }
            else {
                candidateTemp.total_votes =
                    event.target.value !== "" ? parseInt(event.target.value) : 0;
            }
            var finalCandidates = __spreadArray(__spreadArray([], candidateRest, true), [candidateTemp], false);
            finalCandidates.sort(sortFunction);
            setCandidatesResults(finalCandidates);
        }
    };
    var create = useCreate("sequent_backend_tally_sheet")[0];
    var update = useUpdate("sequent_backend_tally_sheet")[0];
    var onSubmit = function (result) { return __awaiter(void 0, void 0, void 0, function () {
        var resultsTemp, invalidsTemp, candidatesResultsTemp, _i, candidatesResults_1, candidate, candiateTemp, tallySheetData;
        return __generator(this, function (_a) {
            resultsTemp = __assign({}, results);
            invalidsTemp = __assign({}, invalids);
            candidatesResultsTemp = {};
            for (_i = 0, candidatesResults_1 = candidatesResults; _i < candidatesResults_1.length; _i++) {
                candidate = candidatesResults_1[_i];
                candiateTemp = {
                    candidate_id: candidate.candidate_id,
                    total_votes: candidate.total_votes,
                };
                candidatesResultsTemp[candidate.candidate_id] = candiateTemp;
            }
            resultsTemp.invalid_votes = invalidsTemp;
            resultsTemp.candidate_results = candidatesResultsTemp;
            tallySheetData = {
                tenant_id: contest.tenant_id,
                election_event_id: contest.election_event_id,
                election_id: contest.election_id,
                contest_id: contest.id,
                area_id: resultsTemp.area_id,
                channel: channel || "",
                content: resultsTemp,
            };
            if (tallySheet && tallySheet.id) {
                update("sequent_backend_tally_sheet", {
                    id: tallySheet.id,
                    data: tallySheetData,
                }, {
                    onSuccess: function () {
                        notify(t("tallysheet.createTallySuccess"), { type: "success" });
                    },
                    onError: function (error) {
                        notify(t("tallysheet.createTallyError"), { type: "error" });
                    },
                });
            }
            else {
                create("sequent_backend_tally_sheet", {
                    data: tallySheetData,
                }, {
                    onSuccess: function () {
                        notify(t("tallysheet.createTallySuccess"), { type: "success" });
                    },
                    onError: function (error) {
                        notify(t("tallysheet.createTallyError"), { type: "error" });
                    },
                });
            }
            return [2 /*return*/];
        });
    }); };
    function CustomTextField(_a) {
        var _b = _a.InputLabelProps, InputLabelProps = _b === void 0 ? {} : _b, props = __rest(_a, ["InputLabelProps"]);
        return _jsx(TextField, __assign({ InputLabelProps: __assign(__assign({}, InputLabelProps), { shrink: true }) }, props));
    }
    return (_jsx(SimpleForm, { toolbar: false, onSubmit: onSubmit, children: _jsxs(_Fragment, { children: [_jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("tallysheet.common.subtitle") }), _jsxs(FormControl, { fullWidth: true, size: "small", children: [_jsx(InputLabel, { children: t("tallysheet.label.area") }), _jsx(Select, { name: "area_id", value: results.area_id || "", label: String(t("tallysheet.label.area")), onChange: handleChange, disabled: true, children: areasList.map(function (item) { return (_jsx(MenuItem, { value: item.id, children: item.name }, item.id)); }) })] }), _jsxs(FormControl, { fullWidth: true, size: "small", children: [_jsx(InputLabel, { children: t("tallysheet.label.channel") }), _jsx(Select, { name: "channel", value: channel || "", label: String(t("tallysheet.label.channel")), onChange: function (e) {
                                var value = e.target.value;
                                setChannel(isTallySheetVotingChannel(value) ? value : null);
                            }, disabled: true, children: votingChannels.map(function (votingChannel) { return (_jsx(MenuItem, { value: votingChannel, children: votingChannel }, votingChannel)); }) })] }), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.data") }) }), _jsx(TextField, { label: String(t("tallysheet.label.contest_id")), name: "constest_id", value: results.contest_id, onChange: handleTextChange, size: "small", disabled: true, style: { display: "none" } }), _jsx(CustomTextField, { label: String(t("tallysheet.label.total_votes")), name: "total_votes", value: results.total_votes, onChange: handleTextChange, size: "small", disabled: true, type: "number" }), _jsx(CustomTextField, { label: String(t("tallysheet.label.total_valid_votes")), name: "total_valid_votes", value: results.total_valid_votes, onChange: handleTextChange, size: "small", disabled: true, type: "number" }), _jsxs(Box, { sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    }, children: [_jsx(CustomTextField, { label: String(t("tallysheet.label.total_invalid")), name: "total_invalid", value: invalids.total_invalid, onChange: handleInvalidChange, size: "small", disabled: true, type: "number" }), _jsx(CustomTextField, { label: String(t("tallysheet.label.implicit_invalid")), name: "implicit_invalid", value: invalids.implicit_invalid, onChange: handleInvalidChange, size: "small", disabled: true, type: "number" }), _jsx(CustomTextField, { label: String(t("tallysheet.label.explicit_invalid")), name: "explicit_invalid", value: invalids.explicit_invalid, onChange: handleInvalidChange, size: "small", disabled: true, type: "number" })] }), _jsx(CustomTextField, { label: String(t("tallysheet.label.total_blank_votes")), name: "total_blank_votes", value: results.total_blank_votes, onChange: handleTextChange, size: "small", disabled: true, type: "number" }), _jsx(CustomTextField, { label: String(t("tallysheet.label.blank_ballots")), name: "blank_ballots", value: results.blank_ballots, onChange: handleTextChange, size: "small", disabled: true, type: "number" }), _jsx(CustomTextField, { label: String(t("tallysheet.label.census")), name: "census", value: results.census, onChange: handleTextChange, size: "small", disabled: true, type: "number" }), _jsx(PageHeaderStyles.Wrapper, { children: _jsx(PageHeaderStyles.Title, { children: t("tallysheet.common.candidates") }) }), candidatesResults.map(function (candidate) { return (_jsxs(Box, { sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "1rem",
                    }, children: [_jsx(Typography, { variant: "body1", sx: { width: "50%" }, children: candidate.name }), _jsx(TextField, { id: candidate.candidate_id, label: String(t("tallysheet.label.total_votes")), name: "total_votes", value: candidate.total_votes, onChange: handleCandidateChange, size: "small", disabled: true, type: "number" })] }, candidate.candidate_id)); }), _jsx("button", { ref: submitRef, type: "submit", style: { display: "none" } })] }) }));
};
